import {
  fetchReplenishmentPlan,
  updateReplenishmentPlanStatus,
} from '../utils/api';

export const REPLENISHMENT_PLAN_FETCH = 'REPLENISHMENT_PLAN_FETCH';
export const REPLENISHMENT_PLAN_ERROR = 'REPLENISHMENT_PLAN_ERROR';
export const REPLENISHMENT_PLAN_RECEIVED = 'REPLENISHMENT_PLAN_RECEIVED';
export const REPLENISHMENT_PLAN_UPDATE_ERROR =
  'REPLENISHMENT_PLAN_UPDATE_ERROR';
export const REPLENISHMENT_PLAN_CLEAR_ERROR = 'REPLENISHMENT_PLAN_CLEAR_ERROR';

export const fetchPlan = (group, deviceCode) => async dispatch => {
  try {
    dispatch({
      type: REPLENISHMENT_PLAN_FETCH,
    });

    const response = await fetchReplenishmentPlan(group, deviceCode);

    const { id, productData, planogram, planogramImageUrl } = response;

    dispatch({
      type: REPLENISHMENT_PLAN_RECEIVED,
      id: id,
      plan: productData ? productData : [],
      planogram,
      planogramImageUrl,
    });
  } catch (error) {
    dispatch({
      type: REPLENISHMENT_PLAN_ERROR,
      error,
    });
  }
};

export const updateStatus = (
  group,
  replenishPlanId,
  status,
  refillOperator
) => async dispatch => {
  try {
    await updateReplenishmentPlanStatus(
      group,
      replenishPlanId,
      status,
      refillOperator
    );
  } catch (error) {
    dispatch({
      type: REPLENISHMENT_PLAN_UPDATE_ERROR,
      error,
    });
  }
};

export const clearError = () => ({
  type: REPLENISHMENT_PLAN_CLEAR_ERROR,
});
